/** @file Screen rotation of a ground part: its drawn azimuth minus the node's azimuth on screen (15.4). */
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/** `wrap(drawnAzimuth - wrap(poseYaw + cameraYaw))` in degrees. */
export function groundRotationOf(poseYawDeg: number, cameraYawDeg: number, drawnAzimuthDeg: number): number {
  return wrapDegrees(drawnAzimuthDeg - wrapDegrees(poseYawDeg + cameraYawDeg));
}
